import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { executeAdminAction, getAdminActions } from '../Functions';
import { handleAdminInfo } from '../../../common/SharedFunctions';

export const AdminActionsButton = ({ data, parentId }) => {
    const { dispatch } = store;
    const { user } = store.getState();

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });

    const onActionClicked = (event, rowItem) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getAdminActions(rowItem, user);

        if (actions.length === 0) {
            handleAdminInfo('No actions available');
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = async (e) => {
        set_actionData({ ...actionData, visible: false });
        executeAdminAction(e.itemData, dispatch);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const isVisible = (rowItem) => {
        const actions = getAdminActions(rowItem, user);
        return actions.length > 0;
    };

    if (!data) {
        return null;
    }

    if (!data || !isVisible(data)) {
        return null;
    }

    return (
        <>
            <button
                id={`${parentId}_action_${data.id ?? 0}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
        </>
    );
};
